export default __webpack_public_path__ + "static/media/phone.8ee95916.png";